import React, { useEffect, useRef, useState } from 'react';
import { useProfile } from '../../../hooks/useProfile';

/*
 * Lo stato della richiesta di fatturazione cambia dal super admin (convalida o rifiuto): finché la struttura ha una richiesta
 * «in attesa» il Manager rilegge il profilo ogni 30 secondi e quando si torna sulla scheda del browser, così banner, Documenti
 * fiscali e le tendine «Genera documento» si aggiornano da soli. Senza richiesta in attesa non fa nessuna chiamata in più.
 * Quando lo stato cambia compare un avviso in basso a sinistra. Montato nel layout della Struttura.
 */
const INTERVALLO = 30 * 1000;

const SincronizzaFatturazione = () => {
    const { profile, fetchProfile } = useProfile({ autoFetch: false });
    const stato = profile?.club?.invoiceDataSender?.status || null;
    const precedente = useRef(stato);
    const [avviso, setAvviso] = useState('');

    // Rilettura periodica, solo con la richiesta in attesa
    useEffect(() => {
        if (stato !== 'WAIT_RESPONSE') return undefined;
        const leggi = () => { if (document.visibilityState === 'visible') fetchProfile(true); };
        const timer = setInterval(leggi, INTERVALLO);
        document.addEventListener('visibilitychange', leggi);
        return () => {
            clearInterval(timer);
            document.removeEventListener('visibilitychange', leggi);
        };
    }, [stato, fetchProfile]);

    // Avviso quando la richiesta passa da «in attesa» a confermata o rifiutata
    useEffect(() => {
        if (precedente.current === 'WAIT_RESPONSE' && stato === 'CONFIRMED') {
            setAvviso('✓ La generazione di ricevute e fatture è stata abilitata');
        } else if (precedente.current === 'WAIT_RESPONSE' && stato === 'REJECTED') {
            setAvviso('La richiesta di fatturazione è stata rifiutata: controlla i dati in Documenti fiscali');
        }
        precedente.current = stato;
    }, [stato]);

    useEffect(() => {
        if (!avviso) return undefined;
        const t = setTimeout(() => setAvviso(''), 8000);
        return () => clearTimeout(t);
    }, [avviso]);

    return avviso ? <div className="sid-avviso-salvato" role="status">{avviso}</div> : null;
};

export default SincronizzaFatturazione;
